import { Component } from 'react'
import * as styles from 'components/features/socialFeed/FeedPostCommentList/FeedPostCommentList.styl'
import { FeedPostCommentContainer } from 'components/features/socialFeed/FeedPost/FeedPostCommentContainer'
import { CommentUid, PostUid, EditingCommentUids } from 'interfaces/feed'
import Spinner from 'components/features/pfm/Spinner/Spinner'
import Deferred from 'components/utils/Deferred'
import { FeedCommentsThread } from 'components/features/socialFeed/FeedCommentsThread/FeedCommentsThread'
import { CommentListMeta } from 'components/features/socialFeed/CommentListMeta/CommentListMeta'
import { CommentListLoadingHandler } from 'components/features/socialFeed/CommentListLoadingHandler/CommentListLoadingHandler'

const DeferredSpinner = Deferred(Spinner, 300)

export type FeedPostCommentListStateProps = {
  itemUids: CommentUid[]
  isLoadMoreShown: boolean
  isLoading: boolean
  hiddenRepliesUids: EditingCommentUids
  commentsCount: number
}

export type FeedPostCommentListDispatchProps = {
  onLoadMore: () => void
}

export type FeedPostCommentListOwnProps = {
  postUid: PostUid
}

export type FeedPostCommentListProps =
  & FeedPostCommentListStateProps
  & FeedPostCommentListDispatchProps
  & FeedPostCommentListOwnProps


class FeedPostCommentList extends Component<FeedPostCommentListProps> {

  render () {
    const { itemUids, isLoadMoreShown, onLoadMore, isLoading, postUid, commentsCount } = this.props
    const hasItems = itemUids.length !== 0

    if (!hasItems && isLoading) {
      return (
        <div className={ styles.loadSpinnerWrapper }>
          <Spinner />
        </div>
      )
    }

    return hasItems && (
      <div className={ styles.container }>
        <CommentListMeta
          commentsCount={ commentsCount || itemUids.length }
          postUid={ postUid }
        />

        <CommentListLoadingHandler postUid={ postUid } />

        <div className={ styles.commentsWrapper }>
          { this.renderCommentChildren() }
        </div>

        { isLoadMoreShown &&
          <div
            className={ styles.hasMore }
            onClick={ isLoading ? undefined : onLoadMore }
          >
            <span className={ styles.hasMoreCopyWrapper }>
              View more comments
              { isLoading && (
                <div className={ styles.spinnerWrapper }>
                  <DeferredSpinner />
                </div>
              )}
            </span>
          </div>}
      </div>
    )
  }

  private renderCommentChildren () {
    const { itemUids, postUid, hiddenRepliesUids } = this.props

    return itemUids.map((uid) => (
      <div key={ uid }>
        <FeedPostCommentContainer commentUid={ uid } parentCommentUid={ uid } />
        { !hiddenRepliesUids[uid] && (
          <FeedCommentsThread commentUid={ uid } postUid={ postUid } />
        )}
      </div>
    ))
  }
}

export default FeedPostCommentList
